import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/components/UserLogin.css'
import ResponseMsg from '../general/ResponseMsg';

const UserLogin = ({ setShowForm }) => {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState('Sign In');
  const [response, setResponse] = useState(null);
  const [responseStatus, setResponseStatus] = useState();
  const [showReset, setShowReset] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });

  const handleButtonClick = (role) => {
    setActiveButton(role);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch('https://api.kcmstore.in/store/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        localStorage.setItem('userData', JSON.stringify(result));
        localStorage.setItem('isUser', 'true');
        setResponse('Login Successful.');
        setResponseStatus('success');
        setTimeout(() => {
          setResponse('');
          navigate('/');
          window.location.reload();
        }, 2000);
      }
      else if (response.status == 400) {
        setResponse(result.message);
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch('https://api.kcmstore.in/store/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        setResponse('Sign Up Successful. Login your account to explore medicine range.');
        setResponseStatus('success');
        setTimeout(() => {
          setResponse('');
        }, 2000)
        setActiveButton('Sign In');
      }
      else if (response.status == 400) {
        setResponse(result.message);
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };


  const handleResetPassword = async (e) => {
    e.preventDefault();
    const { phone, password } = formData;
      setLoading(true);


    try {
      const response = await fetch(`https://api.kcmstore.in/store/reset-password/${phone}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      const result = await response.json();
      setLoading(false);
      if (response.ok) {
        setResponse(result.message);
        setResponseStatus('success');
        setTimeout(() => {
          setShowReset(false);
          setResponse('');
        }, 2000);
      } else {
        setResponse(result.message);
        setResponseStatus('error');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>

      <section className='login-dialog py-3 px-3' onClick={() => setShowForm(false)}>

        <div className='col-lg-4 col-md-6 rounded-2 mx-auto py-3 px-3 bg-white text-center animate__animated animate__zoomIn'
          onClick={(e) => e.stopPropagation()}>

          <span className='float-end cursor-pointer' onClick={() => setShowForm(false)}><i class="fa-solid fa-xmark"></i></span>

          <div className='my-4 d-flex justify-content-center mx-lg-5 mx-md-5'>
            <div style={{border: '1px solid grey'}} className='rounded-pill'>
            <button
              className={`login-btn rounded-start-pill ${activeButton === 'Sign In' ? 'active bg-success text-white' : ''} `} 
              onClick={() => handleButtonClick('Sign In')}>Sign In</button>
            <button
              className={`login-btn rounded-end-pill ${activeButton === 'Sign Up' ? 'active bg-success text-white' : ''}`}
              onClick={() => handleButtonClick('Sign Up')}>Sign Up</button></div>
          </div>

          {response && (
            <p className={`para-text fw-semibold my-3 rounded-2 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
              {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
            </p>
          )}

          {loading && (
            <div>
              <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
            </div>
          )}

          {activeButton === 'Sign In' ? (
            <div className='px-3'>
              {/* <p className='text-center fs-5 fw-semibold fst-italic'>Welcome Back!</p> */}
              <form className='my-3 text-start' onSubmit={handleLogin}>
                <div className='mb-3'>
                  <label htmlFor='phone' className='text-muted fw-semibold'>Mobile Number</label>
                  <input
                    type='tel'
                    className='form-input'
                    name='phone'
                    value={formData.phone}
                    onChange={handleInputChange}
                    id='phone'
                    minLength={10}
                    maxLength={10}
                    required
                  />
                </div>
                <div className='mb-3'>
                  <label htmlFor='password' className='text-muted fw-semibold'>Password</label>
                  <input
                    type='password'
                    className='form-input'
                    name='password'
                  value={formData.password}
                    onChange={handleInputChange}
                    id='password'
                    required
                  />
                </div>
                <button type='submit' className='login-btn2 mt-3 w-100'>Sign In</button>
              </form>
              {/* <p className='text-danger fw-bold cursor-pointer' onClick={() => setShowReset(true)}>Forgot Password?</p> */}
            </div>
          ) : (
            <div className='px-3'>
              {/* <p className='text-center fs-5 fw-semibold fst-italic'>Create An Account</p> */}
              <form className='my-3 text-start' onSubmit={handleSignin}>
                <div className='mb-3'>
                  <label htmlFor='name' className='text-muted fw-semibold'>Name</label>
                  <input
                    type='tel'
                    className='form-input'
                    name='name'
                    value={formData.name}
                    onChange={handleInputChange}
                    id='name'
                    required
                  />
                </div>
                <div className='mb-3'>
                  <label htmlFor='phone' className='text-muted fw-semibold'>Mobile Number</label>
                  <input
                    type='tel'
                    className='form-input'
                    name='phone'
                    value={formData.phone}
                    onChange={handleInputChange}
                    id='phone'
                    minLength={10}
                    maxLength={10}
                    required
                  />
                </div>
                                <div className='mb-3'>
                  <label htmlFor='email' className='text-muted fw-semibold'>Email Address</label>
                  <input
                    type='email'
                    className='form-input'
                    name='email'
                    value={formData.email}
                    onChange={handleInputChange}
                    id='email'
                    required
                  />
                </div>

                <div className='mb-3'>
                  <label htmlFor='password' className='text-muted fw-semibold'>Password</label>
                  <input
                    type='password'
                    className='form-input'
                    name='password'
  minLength={6}
    maxLength={20}                       value={formData.password}
                    onChange={handleInputChange}
                    id='password'
                    required
                  />
                </div>
                <button type='submit' className='login-btn2 mt-3 w-100'>Create Account</button>
              </form>
            </div>
          )}
          {/* </div> */}
          {/* </div> */}

        </div>
      </section>

      {showReset && (
        <section className='delete-dialog px-3' onClick={() => setShowReset(false)}>
          <div className='bg-white col-lg-3 col-md-5 col-10 mx-auto px-3 py-3 rounded-4 animate__animated animate__backInUp' onClick={(e) => e.stopPropagation()}>

            <p className='sec-heading fs-4'>Reset Password</p>

          {response && (
            <p className={`para-text fw-semibold my-3 rounded-2 ${responseStatus === 'success' ? 'text-success' : 'text-danger'}`}>
              {responseStatus === 'success' ? <i className="fa-solid fa-circle-check"></i> : <i className="fa-solid fa-circle-xmark"></i>} {response}
            </p>
          )}

          {loading && (
            <div>
              <i class="fa-solid fa-spinner text-dark animate__animated animate__rotateIn animate__infinite fs-5 mt-3"></i>
            </div>
          )}

            <form className="row g-3 mt-4" onSubmit={handleResetPassword}>
              <div className="col-12 text-start">
                <input
                  type="tel"
                  className="form-input"
                  id="phone"
                  name="phone"
                  placeholder='Enter Mobile Number'
                  maxLength='10'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-12 text-start">
                <input
                  type="password"
                  className="form-input"
                  id="password"
                  name="password"
                  placeholder='Enter New Password'
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="col-12 my-4">
                <button
                  className="danger-btn"
                  onClick={() => setShowReset(false)}
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button type="submit" className="success-btn">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </section>
      )}


    </>
  );
};

export default UserLogin;
